import React, { ChangeEvent, ReactComponentElement, useState } from 'react';
import styles from 'src/components/admin/adminEmailForm.module.scss';
import { ButtonPrimary, Heading, Input } from '@americanexpress/dls-react';
import EmailService from 'src/services/testOnlyEmail.service';
import LiteralsService from 'src/services/literals/LiteralsService';

export default function AdminEmailForm(): ReactComponentElement<any> {
    const [selectedPlanUpdateTime, setPlanUpdateTime] = useState<string>('');
    return (
        <div>
            <Heading level={3}>{LiteralsService.getLiteral('Admin.Email.title')}</Heading>
            <div className={styles.buttonContainer}>
                <ButtonPrimary
                    onClick={async () => {
                        await EmailService.sendBudgetWelcomeEmail();
                    }}
                >
                    {LiteralsService.getLiteral('Admin.Email.welcomeEmailButton')}
                </ButtonPrimary>
                <ButtonPrimary
                    onClick={async () => {
                        await EmailService.sendBudgetAlertEmail();
                    }}
                >
                    {LiteralsService.getLiteral('Admin.Email.alertEmailButton')}
                </ButtonPrimary>
                <ButtonPrimary
                    onClick={async () => {
                        await EmailService.sendMonthlyBudgetEmail();
                    }}
                >
                    {LiteralsService.getLiteral('Admin.Email.monthlyEmailButton')}
                </ButtonPrimary>
            </div>
            <Heading level={3}>{LiteralsService.getLiteral('Admin.Email.cronTitle')}</Heading>
            <div className={styles.buttonContainer}>
                <Input
                    id="plan-update-time"
                    type="datetime-local"
                    value={selectedPlanUpdateTime}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        const { value } = event.target;
                        setPlanUpdateTime(value);
                    }}
                />
                <ButtonPrimary
                    onClick={async () => {
                        await EmailService.executePlanUpdateCron(selectedPlanUpdateTime);
                    }}
                >
                    {LiteralsService.getLiteral('Admin.Email.scheduleCronEmailButton')}
                </ButtonPrimary>
            </div>
        </div>
    );
}
